import { Controller } from "@hotwired/stimulus"

// P24 — Signe de vie de l'écran de piste : un POST au connect puis toutes
// les 30 s vers /live/courts/:token/heartbeat. Silence total sur erreur —
// l'écran ne doit jamais souffrir de la supervision.
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 30000 } }

  connect() {
    this.ping()
    this.timer = setInterval(() => this.ping(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  ping() {
    if (!this.urlValue) return

    try {
      fetch(this.urlValue, { method: "POST", keepalive: true, credentials: "same-origin" })
        .catch(() => {})
    } catch (_e) {
      // rien : silence
    }
  }
}
